import React from 'react';
import { Card, Button } from '../../components/ui';
import Footer from '../../components/layout/Footer';

const BookingSummaryPage = ({ onNavigate }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-orange-100">
        <div className="px-4 py-4 flex items-center">
          <button className="mr-4 p-2 hover:bg-orange-50 rounded-full transition-colors">
            <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-lg font-semibold text-orange-800">Booking Summary</h1>
        </div>
      </header>

      <main className="flex-1 px-4 py-6">
        {/* Booking Details */}
        <div className="space-y-4 mb-6">
          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Pooja Details</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Pandit Info</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Address/Location</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Promo Code</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>

        {/* Payment Button */}
        <Button className="w-full bg-gradient-to-r from-green-500 to-teal-500 hover:from-green-600 hover:to-teal-600 text-white py-4 rounded-xl font-semibold shadow-lg transform hover:scale-105 transition-all duration-200">
          Confirm & Pay ₹XXXXX
        </Button>
      </main>

      {/* Footer */}
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default BookingSummaryPage;

